import React from "react";
import { Textarea } from "components/form-inputs/inputs";
import { setStorageValue } from "shared/storage";
import { DEFAULT_SORT } from "../lib/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSlidersH } from "@fortawesome/free-solid-svg-icons";

export const TaskListExternalFilters = ({ upcs, setUpcs, resetFilters, defaultFilterValues, onShowModalColumns }) => {
    const resetDefault = () => {
        setStorageValue("dup-stage-sort", DEFAULT_SORT);
        setStorageValue("dup-stage-filter", defaultFilterValues);
        resetFilters();
    };

    return (
        <div className="button-group -space-between -flex-end">
            <div>
                <h3>Filter By UPC(s)</h3>
                <div className="upc-filter">
                    <Textarea
                        name="upc"
                        value={upcs}
                        updateOnChange={(id, value) => setUpcs(value)}
                    />
                </div>
            </div>

            <div className="flex align-items-center justify-content-end">
                <button
                    className="button -small -right"
                    onClick={resetDefault}
                >
                    Reset to Default Sort/Filter
                </button>
                <button
                    className="button -small -right"
                    onClick={onShowModalColumns}
                >
                    <FontAwesomeIcon icon={faSlidersH} />
                </button>
            </div>
        </div>
    );
};
